<template>
    <div>
        <div v-margin.top="2" v-margin.bottom="2">
            <v-text type="subheadling">
                Результаты проверки
            </v-text>
        </div>

        <v-row v-for="title, key in companyInfo" align-items="center" :key="key">
            <v-col xs="2">
                <v-text type="caption">
                    {{ title }}
                </v-text>
            </v-col>
            <v-col>
                <v-text>
                    {{ company[key] }}
                </v-text>
            </v-col>
        </v-row>

        <div v-margin.top="2" v-margin.bottom="2">
            <v-text type="subheadling">Балансы</v-text>


        </div>

        <v-row align-items="center">
            <v-col>
                <div v-if="balancesNotFound">
                    <v-text>Балансы не найдены</v-text>
                </div>
                <template v-else>
                    <v-radio v-for="year in company.balances" :key="year" v-model="selectedYear" :label="year.toString()" :data="year"  v-margin.right="2" />
                </template>
            </v-col>
            <v-col v-text-align.right>
                <v-font-icon grey>error</v-font-icon>

                <v-text v-margin.left="1" v-margin.right="4">Итого: {{ total }}</v-text>

                <v-spinner :active="isCreating">
                    <v-button primary :disabled="!selectedYear || isCreating" @click="handleCreateRequest">
                        запросить балансы
                    </v-button>
                </v-spinner>
            </v-col>
        </v-row>
    </div>
</template>

<script>


    export default {
        name: 'company-details',
        props: {
            onCreate: Function,
            company: {
                type: Object,
                default() {
                    return {};
                }
            },
            total: {
                type: Number,
                default: 0,
            }
        },
        data() {
            return {
                selectedYear: undefined,
                isCreating: false,
                companyInfo: {
                    name: 'Наименование',
                    inn: 'ИНН',
                    kpp: 'КПП',
                    ogrn: 'ОГРН',
                    okpo: 'ОКПО',
                    address: 'Адрес',
                },
            }
        },
        methods: {
            handleCreateRequest() {
                this.isCreating = true;

                const fields = {
                    finReportYear: this.selectedYear,
                    orgName: this.company.name,
                    orgInn: this.company.inn,
                };

                this.onCreate({ fields }).then(() => {
                    this.$router.push({ name: 'requests' });
                });
            }
        },
        computed: {
            balancesNotFound() {
                return !this.company.balances || !this.company.balances.length;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CompanyDetails.vue?579eb650